import React, { useCallback, useEffect, useState } from 'react';
import { hr, BASE } from '../../face/hrApi';

const OUTCOME = {
  accepted: ['Accepted', 'ok'], cooldown: ['Repeat', 'off'], unknown: ['Unknown face', 'bad'], ambiguous: ['Unsure', 'warn'],
  spoof: ['Liveness failed', 'bad'], low_quality: ['Poor image', 'warn'], inactive: ['Inactive', 'warn'], error: ['Error', 'bad'],
};
const todayPK = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Karachi' }).format(new Date());
const tm = (d) => new Date(d).toLocaleTimeString('en-GB', { timeZone: 'Asia/Karachi', hour: '2-digit', minute: '2-digit', second: '2-digit' });

export default function FaceLogTab() {
  const [date, setDate] = useState(todayPK());
  const [outcome, setOutcome] = useState('');
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [photo, setPhoto] = useState(null);

  const load = useCallback(async () => {
    try {
      const q = new URLSearchParams({ limit: '200' }); if (date) q.set('date', date); if (outcome) q.set('outcome', outcome);
      setRows((await hr(`/events?${q}`)).events); setErr('');
    } catch (e) { setErr(e.message); }
  }, [date, outcome]);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);

  const showPhoto = async (ev) => {
    try {
      const res = await fetch(`${BASE}/face/events/${ev.id}/snapshot`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      if (!res.ok) throw new Error('No snapshot');
      setPhoto({ url: URL.createObjectURL(await res.blob()), ev });
    } catch (e) { setErr(e.message); }
  };
  const closePhoto = () => { if (photo) URL.revokeObjectURL(photo.url); setPhoto(null); };

  return (
    <div className="fc-card">
      <div className="fc-toolbar">
        <h3>Kiosk activity</h3>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        <select value={outcome} onChange={(e) => setOutcome(e.target.value)}>
          <option value="">All outcomes</option>
          {Object.entries(OUTCOME).map(([k, v]) => <option key={k} value={k}>{v[0]}</option>)}
        </select>
        <button className="fc-btn fc-btn-ghost fc-btn-sm" onClick={load}>Refresh</button>
      </div>
      {err && <div className="fc-callout fc-bad">{err}</div>}
      {!rows ? <div className="fc-muted">Loading…</div> : rows.length === 0 ? <div className="fc-muted">No kiosk activity for this selection.</div> : (
        <div className="fc-table-wrap">
          <table className="fc-table">
            <thead><tr><th>Time</th><th>Employee</th><th>Device</th><th>Outcome</th><th>Punch</th><th>Result</th><th>Match</th><th /></tr></thead>
            <tbody>
              {rows.map((r) => {
                const o = OUTCOME[r.outcome] || [r.outcome, 'off'];
                return (
                  <tr key={r.id}>
                    <td>{tm(r.created_at)}</td>
                    <td>{r.full_name ? <><b>{r.full_name}</b> <span className="fc-muted fc-small">{r.code}</span></> : <span className="fc-muted">—</span>}</td>
                    <td>{r.device || '—'}</td>
                    <td><span className={`fc-pill fc-pill-${o[1]}`} title={r.reason || ''}>{o[0]}</span></td>
                    <td>{r.punch_type ? (r.punch_type === 'in' ? 'Check-in' : 'Check-out') : '—'}{r.punch_type === 'in' && r.would_late_min > 0 ? <div className="fc-small fc-late">{r.would_late_min} min late</div> : null}</td>
                    <td className="fc-small">{r.apply_result ? r.apply_result.replace(/_/g, ' ') : '—'}{r.apply_note ? <div className="fc-muted">{r.apply_note}</div> : null}</td>
                    <td className="fc-small">{r.score != null ? `${Math.round(r.score)}%` : '—'}{r.reason && r.outcome !== 'accepted' ? <div className="fc-muted">{r.reason}</div> : null}</td>
                    <td>{r.has_snapshot ? <button className="fc-link" onClick={() => showPhoto(r)}>photo</button> : null}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {photo && (
        <div className="fc-modal" onClick={closePhoto}>
          <div className="fc-modal-box fc-photo" onClick={(e) => e.stopPropagation()}>
            <img src={photo.url} alt="Kiosk snapshot" />
            <div className="fc-small">{photo.ev.full_name || 'Unknown'} · {tm(photo.ev.created_at)}</div>
            <button className="fc-btn fc-btn-ghost" onClick={closePhoto}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
